import {
  createInventory,
  createWagonInventory,
  deleteInventory,
  updateInventory,
  updateInventoryAndLoadingTime,
} from './Mutations'

export const Inventory = {
  createInventory,
  updateInventory,
  updateInventoryAndLoadingTime,
  deleteInventory,
  createWagonInventory,
}
